<template>
  <div>
<!--    <div class="vx-card mb-4">-->
<!--      รายการ-->
<!--    </div>-->
    <div class="mb-4">
      <AdvisorSchedule />
    </div>
    <div>
      <AdvisorChat />
    </div>
  </div>
</template>

<script>
// import ClassroomStatsStoreModule from "@/developing/store/modules/classroom-stats";
// const StoreModule = ClassroomStatsStoreModule;
// const StoreModuleName = "ClassroomStats";

export default {
  components: {
    AdvisorSchedule: () => import("@/developing/components/advisor/subcomponents/Schedule"),
    AdvisorChat: () => import("@/developing/components/advisor/subcomponents/Chat"),
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  beforeCreate() {
    // if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  },
  destroyed() {
    // this.$store.unregisterModule(StoreModuleName);
  },
}
</script>
